import { Injectable } from '@angular/core';
import {
  HttpResponse,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { SenLoaderService } from './sen-loader.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GlobalVariableService } from "../../common/variables/global-variable";
@Injectable()
export class SenLoaderInterceptorService implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];

  constructor(private loaderService: SenLoaderService, private _snackBar: MatSnackBar, private global: GlobalVariableService) { }

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.loaderService.isLoading.next(this.requests.length > 0);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    this.requests.push(req);

    this.loaderService.isLoading.next(true);
    return Observable.create((observer: any) => {
      const subscription = next.handle(req)
        .pipe(
          retry(1),
          catchError((error: HttpErrorResponse) => {
            let errorMessage = '';
            if (error.error instanceof ErrorEvent) {
              // client-side error
              errorMessage = `Error: ${error.error.message}`;
            } else {
              // server-side error
              errorMessage = `Error Status: ${error.status}\nMessage: ${error.message}`;
            }
            this._snackBar.open(errorMessage);
            return throwError(errorMessage);
          })
        )
        .subscribe(
          event => {
            if (event instanceof HttpResponse) {
              try {
                if (!window.location.origin.includes("localhost"))
                  if ((event.body.ok && !event.body.ok.data.userID) || (event.body.error && !event.body.error.data.userID)) {
                    window.location.href = this.global.loginSol50Url;
                  }
                if (event.body.ok && event.body.ok.message) {
                  this._snackBar.open(event.body.ok.message);
                }
                if (event.body.error && !this.global.skipCodeArray.includes(event.body.error.code)) {
                  this._snackBar.open(event.body.error.message);
                }
              } catch {
              }
              this.removeRequest(req);
              observer.next(event);
            }
          },
          err => {
            // alert('error' + err);
            this.removeRequest(req);
            observer.error(err);
          },
          () => {
            this.removeRequest(req);
            observer.complete();
          })
      // remove request from queue when cancelled
      return () => {
        this.removeRequest(req);
        subscription.unsubscribe();
      };
    });
  }
}
